import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0 w-full',
    wrapper: 'relative overflow-hidden',
    label:
      'peer-disabled:text-text-inactive absolute top-5 left-[12px] -z-10 origin-[0] -translate-y-3 scale-75 transform text-base font-light whitespace-nowrap text-gray-700 transition-all duration-200 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-3 peer-focus:scale-75',
    input:
      'peer disabled:placeholder:text-text-inactive disabled:text-text-inactive border-bg-main-inversion block w-full appearance-none border-0 border-b-1 px-[12px] py-[27px] pb-2 text-base font-light transition-all duration-200 placeholder:text-transparent placeholder:opacity-0 placeholder:transition-all placeholder:duration-200 focus:outline-none focus:placeholder:text-gray-700 focus:placeholder:opacity-100 [&:-webkit-autofill]:[box-shadow:0_0_0_1000px_transparent_inset] [&:-webkit-autofill]:[transition:background-color_5000s_ease-in-out_0s] [&:-webkit-autofill:focus]:[box-shadow:0_0_0_1000px_transparent_inset] [&:-webkit-autofill:hover]:[box-shadow:0_0_0_1000px_transparent_inset]',
    helperText: 'text-text-inactive px-4 pt-1 text-sm font-light',
    iconContainer: 'absolute right-4 bottom-3.5 h-6 w-6 text-gray-700',
    required: 'text-error ml-0.5'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-error',
        input: 'text-error',
        label: 'text-error'
      }
    },
    success: {
      true: {
        helperText: 'text-success'
      }
    },
    white: {
      true: {
        label: 'text-white',
        input: 'border-white text-white',
        helperText: 'text-white'
      }
    },
    icon: {
      true: {
        input: 'pr-12'
      }
    },
    withLabel: {
      true: {
        input: ''
      },
      false: {
        input: 'pt-4 pb-3 placeholder:text-gray-700 placeholder:opacity-100'
      }
    },
    mode: {
      base: '',
      profile: {
        label: 'top-5 -translate-y-3 peer-focus:-translate-y-3 lg:top-5',
        input: 'max-lg:pb-1.5'
      }
    }
  }
});
